<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-main :style="`height:${dispH - 145}px;width:1360px`" class="border-normal">
        <el-row>
          <ImageBox
            :src="imageURL"
            :width="1358"
            :height="dispH - 269"
            :focus="true"
            :colorHex="graphColor"
            :info="getInfo()"
            :proc="getProc()"
            :marking="curMarking"
            :eyetype="getEyeType()"
            :currentUnit="graphUnit"
            :currentPhoto="dispPhoto"
            :curPage="curPage"
            :tearHeight="autocalcPoint"
            :graphMode="graphMode"
            @init-drawtype="btnDrawToolChange"
            @update="update"
            @focus="onImageFocus"
            @paper="selectPaper"
            :mytearheight="mytearheight"
          />
        </el-row>
        <el-row>
          <el-col :span="12">
            <div style="padding-top: 24px">
              <drawType
                v-if="drawTypeShow"
                SubPage="tearheight"
                :toolsBoxWidth="475"
                :toolsBoxHeight="80"
                v-model="graphMode"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="radioContainer">
              <el-radio v-model="currentid" label="0" border @change="selectItem('0')">{{
                $t("langcfg.txtOriginalImg")
              }}</el-radio>
              <el-radio
                v-model="currentid"
                label="1"
                border
                :disabled="radioDisabled"
                @change="selectItem('1')"
                >{{ $t("langcfg.txtTearHeightAreaImg") }}</el-radio
              >
            </div>
          </el-col>
        </el-row>
      </el-main>
      <el-aside width="570px" :style="`height:${dispH - 100}px;padding-bottom:5px`">
        <div class="aside-container">
          <div :style="`width:570px;margin:0 auto;height:${dispH - 120 - 500 - 155}px;`">
            <TrendChart
              :gridRight="60"
              :dispW="550"
              :dispH="dispH - 120 - 500 - 155"
              :trendData="caculateTrendData"
              :xName="'(mm)'"
              :yName="'(mm)'"
              :xRange="{
                min: -6,
                max: 6,
                interval: 2
              }"
              :yRange="{ min: 0, max: 0.5 }"
              :titleVisible="false"
              :title="$t(`langcfg.txtTearHeightTrend`)"
              :tearHeightxAxisData="tearHeightxAxisData"
            />
          </div>
          <div style="width: 100%">
            <h1 class="manualtitle">{{ $t("langcfg.txtTearHeightData") }}</h1>
            <div style="width: 474px; padding: 20px 0; margin-left: 14px">
              <el-form label-position="left" label-width="385px">
                <el-form-item :label="$t('langcfg.txtAutoMeasuredValue') + ':'">
                  <span class="base-font-size">{{ AUTOCALCVALUE }} mm</span>
                </el-form-item>
                <el-form-item :label="$t('langcfg.txtManualAverageMeasurement') + ':'">
                  <span class="base-font-size">{{ AVGVALUE }} mm</span>
                </el-form-item>
                <el-form-item :label="$t('langcfg.txtTearHeightArea') + ':'">
                  <span class="base-font-size">{{ AUTOCALCAREA }} mm²</span>
                </el-form-item>
              </el-form>
            </div>
            <ul class="manualul">
              <li>
                <h1>{{ $t("langcfg.txtManualMeasurement") }}:</h1>
              </li>
              <li class="li-manual-value" v-for="(item, index) in manualData" :key="index">
                M-{{ index + 1 }}：{{ item }} mm
              </li>
            </ul>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import TrendChart from "./basic/TrendChart";
import ImageBox from "../../common/components/ImageBox";
import drawType from "../../common/components/drawType";
import EVENTS from "../../bus";
import { getMarking, updateMarking } from "../../services/media";
import { getImageUrl, hasKey, isDefined } from "../../shared/utils";
import DryEyeApi from "../js/algorithm/DryEyeApi";

let dryEeyApi = new DryEyeApi();
export default {
  name: "TearHeight",
  mixins: [Size, SubPageSize],
  data() {
    return {
      manualData: [],
      zoom: 1.5,
      trendData: {
        tearArrayX: "",
        tearArrayY: ""
      },
      trendData_mock: {
        center: 556,
        X: [
          353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370,
          371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
          389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406,
          407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424,
          425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442,
          443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460,
          461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478,
          479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 496,
          497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514,
          515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532,
          533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550,
          551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 564, 565, 566, 567, 568,
          569, 570, 571, 572, 573, 574, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586,
          587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602, 603, 604,
          605, 606, 607, 608, 609, 610, 611, 612, 613, 614, 615, 616, 617, 618, 619, 620, 621, 622,
          623, 624, 625, 626, 627, 628, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639, 640,
          641, 642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 654, 655, 656, 657, 658,
          659, 660, 661, 662, 663, 664, 665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676,
          677, 678, 679, 680, 681, 682, 683, 684, 685, 686, 687, 688, 689, 690, 691, 692, 693, 694,
          695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 709, 710, 711, 712,
          713, 714, 715, 716, 717, 718, 719, 720, 721, 722, 723, 724, 725
        ],
        Y: [
          9.863265991210938, 9.734305381774902, 9.611050605773926, 9.493332862854004,
          9.380990028381348, 9.273858070373535, 9.17177963256836, 9.07459831237793,
          8.982163429260254, 8.89432430267334, 8.810934066772461, 8.731850624084473,
          8.656932830810547, 8.586042404174805, 8.51904296875, 8.455805778503418, 8.396198272705078,
          8.340095520019531, 8.287372589111328, 8.237909317016602, 8.191584587097168,
          8.148283958435059, 8.107892990112305, 8.070301055908203, 8.035398483276367,
          8.003081321716309, 7.973243236541748, 7.945784091949463, 7.920604705810547,
          7.897608280181885, 7.8767008781433105, 7.857789516448975, 7.840785026550293,
          7.825599670410156, 7.812148094177246, 7.800346374511719, 7.790113925933838,
          7.781371116638184, 7.774041175842285, 7.768049240112305, 7.763321876525879,
          7.759788513183594, 7.757379531860352, 7.756028175354004, 7.755669116973877,
          7.75623893737793, 7.757676124572754, 7.759920597076416, 7.762914180755615,
          7.766601085662842, 7.7709269523620605, 7.775838375091553, 7.781284809112549,
          7.7872161865234375, 7.793585300445557, 7.800344944000244, 7.807450771331787,
          7.814859867095947, 7.822530746459961, 7.830422401428223, 7.838496685028076,
          7.846715927124023, 7.855044841766357, 7.863448619842529, 7.871893882751465,
          7.880349159240723, 7.888784408569336, 7.897169589996338, 7.905477046966553,
          7.913680553436279, 7.921753883361816, 7.929673671722412, 7.9374165534973145,
          7.944960117340088, 7.952284336090088, 7.959368705749512, 7.966195583343506,
          7.9727463722229, 7.979005336761475, 7.98495626449585, 7.990585803985596,
          7.995879173278809, 8.000823974609375, 8.005410194396973, 8.009624481201172,
          8.013460159301758, 8.016904830932617, 8.019951820373535, 8.022594451904297,
          8.024826049804688, 8.026639938354492, 8.028032302856445, 8.028997421264648,
          8.029533386230469, 8.02963638305664, 8.029305458068848, 8.028538703918457,
          8.027334213256836, 8.025693893432617, 8.023616790771484, 8.021102905273438,
          8.018157005310059, 8.014779090881348, 8.01097297668457, 8.00674057006836,
          8.002086639404297, 7.997015476226807, 7.991531848907471, 7.985640525817871,
          7.9793477058410645, 7.972659111022949, 7.96558141708374, 7.9581217765808105,
          7.950286388397217, 7.942083835601807, 7.933521747589111, 7.9246087074279785,
          7.915352821350098, 7.905763149261475, 7.895849227905273, 7.8856201171875,
          7.875085353851318, 7.864255428314209, 7.853140354156494, 7.841750144958496,
          7.8300957679748535, 7.818187713623047, 7.806037425994873, 7.7936553955078125,
          7.781053066253662, 7.768242359161377, 7.7552337646484375, 7.742039680480957,
          7.728671550750732, 7.7151408195495605, 7.701459884643555, 7.68764066696167,
          7.673695087432861, 7.659634590148926, 7.645471572875977, 7.631218433380127,
          7.616886615753174, 7.6024885177612305, 7.588036060333252, 7.573541164398193,
          7.559016227722168, 7.544472694396973, 7.529922008514404, 7.515377044677734,
          7.500848770141602, 7.486348628997803, 7.471888542175293, 7.457480430603027,
          7.443134307861328, 7.42886209487915, 7.414675235748291, 7.400583744049072,
          7.386599063873291, 7.372731685638428, 7.358992099761963, 7.345390319824219,
          7.331936359405518, 7.31864070892334, 7.305512428283691, 7.2925615310668945,
          7.279797077178955, 7.267228603363037, 7.25486421585083, 7.242713451385498,
          7.2307844161987305, 7.219085216522217, 7.2076239585876465, 7.196408748626709,
          7.185445785522461, 7.17474365234375, 7.164309024810791, 7.154148101806641,
          7.144268035888672, 7.134674072265625, 7.125372886657715, 7.116369724273682,
          7.107669830322266, 7.099278926849365, 7.091200351715088, 7.08344030380249,
          7.076001167297363, 7.068888187408447, 7.062104225158691, 7.055652618408203,
          7.049536228179932, 7.043757438659668, 7.038319110870361, 7.0332231521606445,
          7.028470993041992, 7.024064064025879, 7.020003318786621, 7.016289234161377,
          7.012922763824463, 7.009903907775879, 7.007232189178467, 7.00490665435791,
          7.002927303314209, 7.0012922286987305, 7, 6.999049186706543, 6.99843692779541,
          6.998161315917969, 6.9982194900512695, 6.998608112335205, 6.99932336807251,
          7.000361919403076, 7.001719951629639, 7.003392696380615, 7.005375385284424,
          7.007663249969482, 7.010251045227051, 7.013132572174072, 7.016302585601807,
          7.019754409790039, 7.023481845855713, 7.027477741241455, 7.031735420227051,
          7.036247253417969, 7.041005611419678, 7.046002388000488, 7.051229953765869,
          7.0566792488098145, 7.062341690063477, 7.068208694458008, 7.074270248413086,
          7.080517292022705, 7.086940288543701, 7.093529224395752, 7.100273609161377,
          7.107162952423096, 7.114186763763428, 7.121334075927734, 7.128593921661377,
          7.135955333709717, 7.143406391143799, 7.150935173034668, 7.158530235290527,
          7.166179656982422, 7.1738715171813965, 7.1815924644470215, 7.189330577850342,
          7.197073459625244, 7.204808235168457, 7.212521553039551, 7.220200538635254,
          7.227832794189453, 7.235404014587402, 7.24290132522583, 7.250311374664307,
          7.257620811462402, 7.264815807342529, 7.2718825340271, 7.278807640075684,
          7.285577774047852, 7.292178630828857, 7.2985968589782715, 7.304818153381348,
          7.3108296394348145, 7.316617012023926, 7.322166919708252, 7.327465534210205,
          7.332499027252197, 7.337254047393799, 7.341717720031738, 7.3458757400512695,
          7.349715232849121, 7.3532233238220215, 7.356386661529541, 7.359192371368408,
          7.361627578735352, 7.363679885864258, 7.365337371826172, 7.366586685180664,
          7.367416858673096, 7.3678154945373535, 7.367771625518799, 7.367272853851318,
          7.36630916595459, 7.364869594573975, 7.362942695617676, 7.3605194091796875,
          7.3575897216796875, 7.3541436195373535, 7.35017204284668, 7.34566593170166,
          7.3406171798706055, 7.335017681121826, 7.328860282897949, 7.322136402130127,
          7.314840793609619, 7.3069658279418945, 7.298506736755371, 7.28945779800415,
          7.279813766479492, 7.269570827484131, 7.258725643157959, 7.247273921966553,
          7.235213756561279, 7.222543239593506, 7.2092604637146, 7.195364952087402,
          7.180857181549072, 7.165737152099609, 7.15000581741333, 7.133666038513184,
          7.116719722747803, 7.099171161651611, 7.081024169921875, 7.062283515930176,
          7.04295539855957, 7.023046493530273, 7.002564430236816, 6.981517791748047,
          6.9599151611328125, 6.937767505645752, 6.915085792541504, 6.891881465911865,
          6.868168830871582, 6.843961238861084, 6.819273471832275, 6.794122695922852,
          6.76852560043335, 6.742500305175781, 6.716066360473633, 6.689244747161865,
          6.6620564460754395, 6.634524822235107, 6.6066741943359375, 6.578529357910156,
          6.550117492675781, 6.52146577835083, 6.492603778839111, 6.46356201171875,
          6.4343719482421875, 6.405067443847656, 6.375682353973389, 6.346252918243408,
          6.316816806793213, 6.287412643432617, 6.258081436157227, 6.2288641929626465,
          6.19980525970459, 6.170949459075928, 6.142343044281006, 6.114034652709961,
          6.086074352264404, 6.058513641357422, 6.031405448913574, 6.004805564880371,
          5.978770732879639, 5.9533586502075195, 5.928630828857422, 5.904648780822754,
          5.881476879119873, 5.8591814041137695, 5.837830066680908, 5.817492961883545,
          5.79824161529541, 5.780150413513184, 5.7632951736450195, 5.747754096984863,
          5.733606815338135, 5.720935821533203, 5.70982551574707, 5.700362682342529,
          5.692635536193848, 5.686736106872559, 5.682757377624512
        ]
      },
      autoMeasureValue: "--",
      autocalcarea: "--", // 泪河面积
      trensdDataYHeigth: null, // 自动测量值
      autocalcvalueText: "--",
      autocalcPoint: {}, // 坐标obj
      isHugeMapVisible: false,
      currentid: "0",
      trendThumbnail: "",
      originalThumbnail: "",
      graphMode: "Select",
      graphColor: "#00ff00",
      dispPhoto: {},
      graphUnit: "mm",
      imageListId: 0,
      curTearHeight: "--",
      curRecord: {},
      drawTypeShow: true,
      mytearheight: {},
      curMarking: "",
      radioDisabled: false,
      tearHeightxAxisData: ["6", "4", "2", "0", "2", "4", "6"],
      trenddatacenter: 0,
      curPage: "tearheight"
    };
  },
  props: {
    record: {
      type: Object,
      default: () => {}
    },
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  watch: {
    currentEye(newType) {
      this.currentEye = newType;
      this.ifOS(this.record);
      this.selectItem("0");
      this.getPhotoMarking();
    }
  },
  mounted() {
    this.ifOS(this.record);
    this.selectItem("0");
    this.$bus.$emit(EVENTS.uploadingThirdyParty, "tearheight");
  },
  components: {
    TrendChart,
    ImageBox,
    drawType
  },
  methods: {
    fomater(val) {
      return Math.abs(val - 6);
    },
    selectItem(id) {
      this.currentid = id;
      let photos = [];
      if (!hasKey(this.curRecord, `content.data${this.currentEye}.tearheight.photos`)) return;
      photos = this.curRecord.content[`data${this.currentEye}`][`tearheight`].photos;
      // 先判断接口中是否有trend图片 给与相应disabled
      if (photos.filter((photo) => photo.imagelabel === "trend").length === 0)
        this.radioDisabled = true;
      // es6 filter过滤
      if (id === "0") {
        this.dispPhoto = photos.filter((photo) => photo.imagelabel === "original")[0];
        this.drawTypeShow = true;
        this.getPhotoMarking();
      } else if (id === "1") {
        this.dispPhoto = photos.filter((photo) => photo.imagelabel === "trend")[0];
        this.drawTypeShow = false;
        this.getPhotoMarking();
      }
    },
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    btnDrawToolChange(val) {
      this.graphMode = val;
    },
    ifOS(record) {
      this.curRecord = JSON.parse(JSON.stringify(record));

      if (!hasKey(record, `content.data${this.currentEye}`)) return;
      let { tearheight } = this.curRecord.content[`data${this.currentEye}`];
      if (!isDefined(tearheight)) return;
      if (tearheight.lightType === "hw") {
        this.curPage = "tearheight_infrared";
      }
      this.curTearHeight =
        isDefined(tearheight["manualMeasureAvg"]) && tearheight["manualMeasureAvg"] > 0
          ? Math.round(tearheight.manualMeasureAvg * 100) / 100
          : "--";
      this.autocalcarea = tearheight.autocalcarea;
      this.autocalcPoint = tearheight.cloneautocalcPoint = tearheight.autocalcPoint
        ? tearheight.autocalcPoint
        : tearheight.cloneautocalcPoint;
      this.trensdDataYHeigth = tearheight.trensdDataYHeigth
        ? tearheight.trensdDataYHeigth
        : tearheight.clonetrensdDataYHeigth;
      tearheight.clonetrensdDataYHeigth = this.trensdDataYHeigth;
      this.mytearheight = tearheight;

      this.showThumbnailImage();
      if (this.curRecord.content[`data${this.currentEye}`]["tearheight"].manualMeasureArr) {
        this.manualData =
          this.curRecord.content[`data${this.currentEye}`]["tearheight"].manualMeasureArr;
      } else {
        this.manualData = [];
      }
      const { trendData, trenddatacenter } = tearheight;
      this.trendData.tearArrayX = trendData.X ? trendData.X : [];
      this.trendData.tearArrayY = trendData.Y ? trendData.Y : [];
      this.trenddatacenter = trenddatacenter;
    },
    showThumbnailImage() {
      if (hasKey(this.curRecord, `content.data${this.currentEye}.tearheight.photos`)) {
        for (let image of this.curRecord.content[`data${this.currentEye}`].tearheight.photos) {
          if (image.imagelabel === "original") {
            this.originalThumbnail = image.thumbnail;
          } else if (image.imagelabel === "trend") {
            this.trendThumbnail = image.thumbnail;
          }
        }
      }
    },
    getPhotoMarking() {
      if (this.dispPhoto && this.currentid === "0") {
        getMarking(this.dispPhoto.filename, (res) => {
          if (res.message === "OK") {
            this.curMarking = res.marking;
          } else {
            this.curMarking = "";
          }
        });
      } else {
        this.curMarking = "";
        return null;
      }
    },
    updatePhotoMarking(marking) {
      if (this.dispPhoto && this.currentid === "0") {
        updateMarking(this.dispPhoto.filename, marking, (res) => {
          if (res.message === "OK") {
            this.curMarking = marking;
          } else {
            this.curMarking = "";
          }
        });
      } else {
        this.curMarking = "";
        return null;
      }
    },
    getInfo() {
      let info = {
        eyeType: "os",
        magnification: "16"
      };
      if (this.dispPhoto) return info;
      else return undefined;
    },
    getProc() {
      if (this.dispPhoto) return this.dispPhoto.imgproc;
      else return undefined;
    },
    getEyeType() {
      return this.currentEye;
    },
    update(marking, seg, curTearHeight, delAuto) {
      if (curTearHeight.contents_array.length === 0) {
        // 用接口里的 manualData
      } else {
        // 手动画后更新掉数组并上传新值
        this.manualData = curTearHeight.contents_array;
        // console.log('初始获取的api的值', this.manualData)
      }
      let avgValue = curTearHeight.avg;
      if (curTearHeight.clear) {
        this.manualData = curTearHeight.contents_array;
        this.curTearHeight = 0;
      } else {
        this.curTearHeight = avgValue < 0 ? this.curTearHeight : avgValue.toFixed(2);
      }
      // 手动均值
      let calue =
        curTearHeight.avg > 0 &&
        curTearHeight.contents_array.length > 0 &&
        curTearHeight.contents > 0;
      if (calue || curTearHeight.clear) {
        this.curRecord.content[`data${this.currentEye}`]["tearheight"].manualMeasureAvg =
          this.curTearHeight;
        this.curRecord.content[`data${this.currentEye}`]["tearheight"].manualMeasureArr =
          this.manualData;
        this.curRecord.content[`data${this.currentEye}`]["tearheight"].clonetrensdDataYHeigth = this
          .curRecord.content[`data${this.currentEye}`]["tearheight"].trensdDataYHeigth
          ? this.curRecord.content[`data${this.currentEye}`]["tearheight"].trensdDataYHeigth
          : this.curRecord.content[`data${this.currentEye}`]["tearheight"].clonetrensdDataYHeigth;
        this.curRecord.content[`data${this.currentEye}`]["tearheight"].cloneautocalcPoint = this
          .curRecord.content[`data${this.currentEye}`]["tearheight"].autocalcPoint
          ? this.curRecord.content[`data${this.currentEye}`]["tearheight"].autocalcPoint
          : this.curRecord.content[`data${this.currentEye}`]["tearheight"].cloneautocalcPoint;
        this.curRecord.content[`data${this.currentEye}`]["tearheight"].trensdDataYHeigth = null;
        this.curRecord.content[`data${this.currentEye}`]["tearheight"].autocalcPoint = null;
        // if (curTearHeight.clear) { // 用于记录是否删除全部标记(报告后面会识别)
        //   this.curRecord.content[`data${this.currentEye}`]['tearheight'].hasDeleteAutoPoint = true
        //   this.curRecord.content[`data${this.currentEye}`]['tearheight'].clonetrensdDataYHeigth = '--'
        //   this.trensdDataYHeigth = '--'
        // } else {
        //   this.curRecord.content[`data${this.currentEye}`]['tearheight'].hasDeleteAutoPoint = false
        // }
        if (delAuto && curTearHeight.clear) {
          this.curRecord.content[`data${this.currentEye}`]["tearheight"].clonetrensdDataYHeigth =
            "--";
          this.trensdDataYHeigth = "--";
        }
        if (this.record.content[`data${this.currentEye}`]["tearheight"].uploaded) {
          this.$bus.$emit(EVENTS.uploadingThirdyParty, "tearheight", this.curRecord, true);
        }
        this.$bus.$emit(EVENTS.updateData, this.curRecord, this.dispPhoto, marking, () => {});
        this.updatePhotoMarking(marking);
      }
    },
    onImageFocus(dispid, paper) {
      this.currPaper = paper;
    },
    selectPaper(g, paper) {
      this.graph = g;
      this.currPaper = paper;
    }
  },
  computed: {
    // 泪河面积
    AUTOCALCAREA() {
      let deal = this.autocalcarea * Math.pow(window.magecoe[this.curPage], 2);
      if (!isDefined(this.autocalcarea) || this.autocalcarea === -1) return "--";
      else deal = deal.toFixed(2);
      return deal;
    },
    // 手动测量平均值
    AVGVALUE() {
      if (this.curTearHeight) return this.curTearHeight;
      else return "--";
    },
    AUTOCALCVALUE() {
      let deal;

      deal = this.trensdDataYHeigth * window.magecoe[this.curPage];
      if (!isDefined(this.trensdDataYHeigth) || this.trensdDataYHeigth < 0) return "--";
      else deal = deal.toFixed(2);
      if (this.trensdDataYHeigth === "--") {
        deal = "--";
      }
      return deal;
    },
    caculateTrendData() {
      let pxRate = window.magecoe[this.curPage];
      let centerAxias = this.trenddatacenter;
      let a = this.trendData.tearArrayX;
      let b = this.trendData.tearArrayY;
      let seriesdata = [];
      for (let i = 0; i < a.length; i++) {
        seriesdata.push([(a[i] - centerAxias) * pxRate, b[i] * pxRate]);
      }
      return seriesdata;
    },
    imageURL() {
      return getImageUrl((this.dispPhoto || {}).filename, window.server, window.token);
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
.radioContainer {
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  line-height: 80px;
}
.radioContainer .el-radio {
  height: 80px;
  line-height: 80px;
  padding: 0 20px;
}
.radioContainer .el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
.base-font-size {
  font-size: 24px;
  float: right;
  margin-right: -14px;
}
/deep/.el-form-item__label {
  // margin-left: 5px;
  font-size: 24px;
}
.manualtitle {
  line-height: 40px;
  height: 40px;
  background: #606266;
  text-align: center;
  font-size: 23px;
  margin-top: 35px;
}
.li-manual-value {
  margin-top: 10px;
}
.manualul {
  // height: 414px;
  margin-left: 18px;
  height: 300px;
  overflow-y: auto;
  font-size: 20px;
  margin-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/TearHeight.vue